export default {
      id: "av_lk-usage",
      viewBox: "0 0 50 51",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#av_lk",
      toString: function () {
        return this.url;
      }
    }